/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1UserCommandServiceSetUserPreferences } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-user-command-service-set-user-preferences';
import type { IxmUserauthV1UserCommandServiceSetUserPreferencesRequest, IxmUserauthV1UserCommandServiceSetUserPreferencesResponse } from '@interxfi/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { ixmUserauthV1UserStateEntity } from '../entities/ixm-userauth-v1-user-state';

/**
 * @generated by NormalizedQueryPlugin (post /portal/userauth/v1/user/c/:userId/preferences/set) */

export function buildIxmUserauthV1UserCommandServiceSetUserPreferencesKey() { return ['/ixm.userauth.v1.UserCommandService/SetUserPreferences'] as const; }

export function useIxmUserauthV1UserCommandServiceSetUserPreferences(options?: Partial<UseMutationOptions<IxmUserauthV1UserCommandServiceSetUserPreferencesResponse | undefined, Error, IxmUserauthV1UserCommandServiceSetUserPreferencesRequest, unknown>>) {
    return useMutation({
        mutationKey: buildIxmUserauthV1UserCommandServiceSetUserPreferencesKey(),
        mutationFn: async (request: IxmUserauthV1UserCommandServiceSetUserPreferencesRequest) => ixmUserauthV1UserCommandServiceSetUserPreferences('', request),
        ...options
    });
}
